var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"requests"}},[_c('requests-list',{attrs:{"request-api-path":"/request","request-details-route":"/requests"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }